<ng-container *ngIf="state">
  <a class="square {{ styleMode }}" [class.filter]="filter" draggable="false">
    <div class="content">
      <img [src]="state.getArmsImageUrl('big')" alt="Wappen" draggable="false">
      <div class="name">
        <p class="name">{{ state.name }}</p>
      </div>
      <img *ngIf="filter" class="mini-filter" src="assets/icons/filter.svg" alt="Filter Icon">
    </div>
  </a>
</ng-container>

<ng-container *ngIf="league">
  <a class="square {{ styleMode }}" [class.filter]="filter" appClearHref [href]="link" draggable="false">
    <div class="content">
      <img [src]="league.getLogoImageUrl('big')" alt="Wappen" draggable="false">
      <div class="name">
        <p class="name">{{ league.name }}</p>
      </div>
      <img *ngIf="filter" class="mini-filter" src="assets/icons/filter.svg" alt="Filter Icon">
    </div>
  </a>
</ng-container>

<ng-container *ngIf="team">
  <a class="square {{ styleMode }}" [class.filter]="filter" appClearHref [href]="link" draggable="false">
    <div class="content">
      <img [src]="team.getLogoImageUrl('medium')" alt="Wappen" draggable="false">
      <div class="name">
        <p class="name">{{ team.name }}</p>
      </div>
      <img *ngIf="filter" class="mini-filter" src="assets/icons/filter.svg" alt="Filter Icon">
    </div>
  </a>
</ng-container>

<ng-container *ngIf="custom != null && custom.image != null && custom.name != null">
  <a class="square {{ styleMode }}" [class.filter]="filter" draggable="false">
    <div class="content">
      <img [src]="custom.image" alt="Wappen" draggable="false">
      <div class="name">
        <p class="name">{{ custom.name }}</p>
      </div>
      <img *ngIf="filter" class="mini-filter" src="assets/icons/filter.svg" alt="Filter Icon">
    </div>
  </a>
</ng-container>
